// @flow

import styled, { css } from 'styled-components';
import type { Theme } from '../../../../types';

type Props = {
  boxed: boolean,
};

export default styled<any, Theme, Props>('div')`
  box-sizing: border-box;
  width: 100%;
  padding: 0;
  ${props => props.boxed && css`
    background-color: ${props.theme.gallery.backgroundColor};
    border-radius: ${props.theme.gallery.borderRadius};
    box-shadow: ${props.theme.gallery.boxShadow};
    /* This is needed for now to avoid cutted shadows */
    margin-top: .25rem;
    transform: translateY(-.25rem);
  `}
`;
